export default "__VITE_ASSET__d82a3a20__"